<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="dialogTitleTheme || 'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ dialogTitle || ('dialogs.defaults.informationTitle' | translate) }}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)" [attr.aria-label]="'dialogs.defaults.closeAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <div [innerHTML]="dialogBody"></div>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" [fxLayoutAlign]="leftButton ? 'space-between' : 'end'">

        <ng-container *ngIf="leftButton">
            <button [attr.data-test]="'B-' + leftButton.text" mat-flat-button [color]="leftButton.color" (click)="leftButton.onClick(); dialogRef.close(true)">{{leftButton.text}}</button>
        </ng-container>

        <button [attr.data-test]="'B-' + dialogButton.text" mat-flat-button [color]="dialogButton.color" (click)="dialogRef.close(true)">{{dialogButton.text}}</button>

    </div>
</div>
